import React from 'react';
//import classes from './Spinner.css';

const spinner = ({ show }) => {
  // if (!show) return null;

  return (
    <div className="overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default spinner;
